import VideoPlaceholder from 'components/VideoPlaceholder';
import LocalVideo from 'components/LocalVideo';
import { selectVideoFacingMode } from 'features/user-media/userMediaSlice';
import { useAppSelector } from 'store/hooks';
import { selectLocalUser } from 'features/users/usersSlice';
import { selectMirrorVideo } from 'features/streaming/streamingSlice';
import AspectRatio from 'components/AspectRatio';
import { Box, BoxProps } from '@mui/material';

type VideoRendererProps = {
  mediaStream: MediaStream | null;
  ratio?: number;
  className?: string;
  loading?: boolean;
};

const VideoRenderer = ({
  mediaStream,
  ratio,
  loading,
  sx = [],
  ...props
}: BoxProps<'div', VideoRendererProps>) => {
  const user = useAppSelector(selectLocalUser);
  const facingMode = useAppSelector(selectVideoFacingMode);
  const mirrorVideo = useAppSelector(selectMirrorVideo);

  return (
    <Box
      sx={[
        (theme) => ({
          bgcolor: user?.avatarColor ?? theme.room.tileBackground,
          overflow: 'hidden',
          borderRadius: '8px',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      data-testid="video-renderer"
      {...props}
    >
      <AspectRatio ratio={ratio}>
        {mediaStream?.active ? (
          <div>
            <LocalVideo
              srcObject={mediaStream}
              mirror={mirrorVideo && facingMode !== 'environment'}
            />
          </div>
        ) : (
          <VideoPlaceholder loading={loading} />
        )}
      </AspectRatio>
    </Box>
  );
};
export default VideoRenderer;
